export function resolveRoleAwareRootDocReady({
  isLocal,
  isRootDocSynced,
  isPermissionCachePopulated,
  requirePermissionCache,
}: {
  isLocal: boolean;
  isRootDocSynced: boolean;
  isPermissionCachePopulated: boolean;
  requirePermissionCache: boolean;
}): boolean {
  if (isLocal) {
    return isRootDocSynced;
  }
  return requirePermissionCache ? isPermissionCachePopulated : true;
}
